import { Users, Send, CheckCircle2, Receipt, Banknote, Hourglass, Headphones } from "lucide-react";
import { fmt, rd, FunnelList } from "./fniShared";

function Kpi({ icon: Icon, label, value, sub, color, testid }) {
  return (
    <div className="surface p-4 min-w-0" data-testid={testid}>
      <div className="flex items-center gap-2 mb-2">
        <span className="kpi-icon-clean" style={{ width: 30, height: 30, color, boxShadow: `inset 0 0 0 1px ${color}33` }}>
          <Icon size={15}/>
        </span>
        <span className="label-up text-[10px]">{label}</span>
      </div>
      <div className="font-display font-extrabold text-[26px] leading-none" style={{ color }} data-testid={`${testid}-value`}>{value}</div>
      {sub && <div className="text-[11px] font-semibold text-gray-500 mt-1.5">{sub}</div>}
    </div>
  );
}

export default function FniExecutive({ t, onPick }) {
  return (
    <section className="grid gap-4 mb-5 lg:grid-cols-[1fr_340px]" data-testid="fni-executive">
      <div className="grid gap-3 grid-cols-2 xl:grid-cols-4 auto-rows-fr">
        <Kpi icon={Users} label="Leads" value={fmt(t.leads)} color="#0f172a" testid="fni-kpi-leads"
             sub={`${fmt(t.asignados)} asignados · ${fmt(t.descalificado)} descalif.`}/>
        <Kpi icon={Headphones} label="Leads en Contact Center" value={fmt(t.cc_leads)} color="#64748b" testid="fni-kpi-cc"
             sub="Incluidos en Leads · aún sin sucursal"/>
        <Kpi icon={Send} label="Sometidas a banco" value={fmt(t.sometido)} color="#0891b2" testid="fni-kpi-sometido"
             sub={`de ${fmt(t.oportunidad)} oportunidades`}/>
        <Kpi icon={CheckCircle2} label="Tasa de aprobación" value={`${t.approval_rate}%`} color="#059669" testid="fni-kpi-approval"
             sub={`${fmt(t.aprobado)} aprobadas + ${fmt(t.firmado)} firmadas`}/>
        <Kpi icon={Hourglass} label="En espera del banco" value={fmt(t.en_espera)} color="#d97706" testid="fni-kpi-espera"
             sub={`Sometido / Pre-Aprobado · ${fmt(t.rechazado)} rechazadas · ${fmt(t.desestimado)} desestimadas`}/>
        <Kpi icon={Receipt} label="Facturado" value={fmt(t.facturado)} color="#7c3aed" testid="fni-kpi-facturado"
             sub={`${fmt(t.facturado_financiado)} financiadas · sin Yamaha ni Gobierno`}/>
        <Kpi icon={Banknote} label="Monto sometido (est.)" value={rd(t.monto_sometido)} color="#0f766e" testid="fni-kpi-monto"
             sub={`${fmt(t.con_monto)} oportunidades con cotización`}/>
        <Kpi icon={Banknote} label="Monto aprobado (est.)" value={rd(t.monto_aprobado)} color="#059669" testid="fni-kpi-monto-aprobado"
             sub="Aprobado + Firmado"/>
      </div>
      <div className="surface p-4" data-testid="fni-total-funnel">
        <h3 className="font-display font-extrabold text-base mb-3">Embudo de financiamiento</h3>
        <FunnelList data={t} onPick={(stage) => onPick({ stage })} testid="fni-funnel-total"/>
      </div>
    </section>
  );
}
